// fallow-ignore-file duplicate-export
import dayjs from 'dayjs';
/* oxlint-disable-next-line import/no-unassigned-import */
import 'dayjs/locale/de';
/* oxlint-disable-next-line import/no-unassigned-import */
import 'dayjs/locale/en';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

// Register plugins
dayjs.extend(customParseFormat);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(quarterOfYear);
dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(utc);

dayjs.locale('de'); // Globally select German locale by default -> TODO: link this to language switch

export type DateLike = Date | string | number;

export type DateRange = [string, string];

export { default as dayjs } from 'dayjs';
